import { RootState } from "redux/rootReducer";

export const selectIsPostingStatement = (state: RootState) =>
  state.postConsentStatement.loading;
export const selectPostStatementErrorMessage = (state: RootState) =>
  state.postConsentStatement.error;
export const postStatementResponse = (state: RootState) =>
  state.postConsentStatement.postConsentStatementResponse;
